const Constant = {
    // Firestore Dev Tables
    USERS: 'USERS',
    CHAT_LIST: 'CHAT_LIST',
    MESSAGES: 'MESSAGES',
  };
  export {Constant};
  